import React from 'react';
import BankLoanForm from './BankLoanForm';

export default function NBFCHomeForm({ setScore, onComputed }) {
  return <BankLoanForm buttonLabel="Calculate Home Loan Score" setScore={setScore} onComputed={onComputed} />;
}


